<template>
    <div class="Collapsible-warper">
      
        <div class="container">
        <h2>S.D.Escobedo</h2>
        <p class="paragraph">
        <ul>
        <div v-for="(item, index) in customItems" :key="item.index" class="collapsible-item">
            <div @click="activateBody(index, item.desc)" class="collapsible-item-header">
                <li><strong>{{item.header}}</strong></li>
            </div>
            <transition name="slide-fade">
            <div v-html = "item.body" v-if="item.active" class="collapsible-item-body"></div>
            </transition>
        </div>
        </ul>
        </p>
        </div>
        <div class="explanation">
            <transition name="fade">
              <i v-show="show"><strong v-html="desc"></strong></i>
            </transition>
        </div>
        
      
    </div>
</template>

<script>
export default {
    props: ["items"],
    data(){
        return {
            collapsibleItems: [],
            show: false,
            desc: 'demostration string'
        }
    },
    computed : {
        customItems(){
            this.collapsibleItems = this.items.map((item)=>{ 
            return {
                header: item.header,
                body: item.body,
                desc: item.desc,
                active: false
            }}
            );
         return this.collapsibleItems;   
        }
    },
    methods : {
        activateBody(index, desc){
            this.desc = desc
            this.collapsibleItems[index].active = !this.collapsibleItems[index].active
            this.collapsibleItems.forEach((item, ind) => {
                if(ind!==index){
                    item.active = false;
                }
                else{
                  this.show = item.active
                }
            });
        }
    }
}
</script>


<style scoped>

a {
 color: black;
 text-decoration: none;
}

a:hover {
  color: #920142;
  
}
div.container {
  height: 100px;
  padding: 2%;
  margin-top: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:15px;
  }

.options {
  color:black;
  
}
div.container p {
  margin: 0 }
div.container h2 {
  font-size:16px;
}
.paragraph{
  width: 300px;
  height: 120px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.collapsible-warper{
    width: 50%;
    height: auto;
}
.collapsible-item-header{
    cursor: pointer;

}
.collapsible-item-header:hover{
    color: #920142;
}

.collapsible-item-body{
    padding: 12px;
}

.collapsible-item-body.a {
 color: black;
 text-decoration: none;
}
.collapsible-item-body.a:hover {
 color: #920142;
}

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(200px);
}
div.explanation {
  height: 60px;
  padding: 10px;
  margin-top: 170px;
  margin-left: 0;
  margin-right: 0;
  width: 99%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:15px;
  }

@media only screen and (max-width: 600px) {
  div.container {
  height: 150px;
  padding: 2%;
  margin-top: 120px;
  font-size:14px;
  flex-direction: column;
  }
  div.explanation {
  height: 60px;
  padding: 10px;
  margin-top: 170px;
  font-size:14px;
  }
  div.container h2 {
  font-size:15px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/collapsible.vue